<template>
  <div class="row">
    <div class="col-12 col-lg-5">
      <p class="text-truncate">
        <span class="strong">{{ warranty.client }}</span><br/>
        <span class="d-inline-block mt-1">{{ warranty.project }}</span>
      </p>
    </div>
    <div class="col-6 col-lg-2">
      <p class="text-truncate">
        <span class="data-label d-lg-none">Evaluation End:</span>
        {{ warranty.evaluation_end || '-' }}
      </p>
    </div>
    <div class="col-6 col-lg-3">
      <p class="text-truncate">
        <span class="data-label d-lg-none">Warranty Period:</span>
        {{ warranty.warranty_start || '?' }} - {{ warranty.warranty_end || '?' }}
      </p>
    </div>
    <div class="col-6 col-lg-2 justify-content-lg-end">
      <span class="status" :class="statusClass">{{ warranty.status }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    warranty: {
      required: true,
      type: Object
    }
  },

  computed: {
    statusClass () {
      // Values from the project stage warranty_status attribute
      switch (this.warranty.status) {
        case 'Warranty':
          return 'status-success'
        case 'Evaluation':
          return 'status-primary'
        case 'Expired':
          return 'status-danger'
      }

      // Pending: chameleon's plain .status (grey dot)
      return ''
    }
  }
}
</script>
